<template>
    <form @change="isFormDirty" @submit.prevent="handleSubmit" class="form-container" data-cy="form-container">
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>
        <div class="form-section">
            <div class="section-body" data-cy="section-general">
                <div class="input-container mb-2 px-4 w-1/2" data-cy="template-certificate-type-field">
                    <ui-label>{{ $t('template.forms.main.certificate_type') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.template.certificate_type.$error }"
                        v-model="v$.template.certificate_type.$model"
                    />
                </div>
                <div class="input-container mb-2 px-4 w-1/2" data-cy="template-certificate-code-field">
                    <ui-label>{{ $t('template.forms.main.certificate_code') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.template.certificate_code.$error }"
                        v-model="v$.template.certificate_code.$model"
                    />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-one-label-field">
                    <ui-label>{{ $t('template.forms.main.section_1_label') }}</ui-label>
                    <ui-input v-model="v$.template.section_1_label.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-one-field">
                    <ui-label>{{ $t('template.forms.main.section_1') }}</ui-label>
                    <ui-text-area v-model="v$.template.section_1.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-two-label-field">
                    <ui-label>{{ $t('template.forms.main.section_2_label') }}</ui-label>
                    <ui-input v-model="v$.template.section_2_label.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-two-field">
                    <ui-label>{{ $t('template.forms.main.section_2') }}</ui-label>
                    <ui-text-area v-model="v$.template.section_2.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-three-label-field">
                    <ui-label>{{ $t('template.forms.main.section_3_label') }}</ui-label>
                    <ui-input v-model="v$.template.section_3_label.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-three-field">
                    <ui-label>{{ $t('template.forms.main.section_3') }}</ui-label>
                    <ui-text-area v-model="v$.template.section_3.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-four-label-field">
                    <ui-label>{{ $t('template.forms.main.section_4_label') }}</ui-label>
                    <ui-input v-model="v$.template.section_4_label.$model" />
                </div>
                <div class="input-container mb-2 px-4 w-full" data-cy="template-section-four-field">
                    <ui-label>{{ $t('template.forms.main.section_4') }}</ui-label>
                    <ui-text-area v-model="v$.template.section_4.$model" />
                </div>
            </div>
        </div>
        <div class="drawer-footer">
            <slot name="actions"></slot>
            <a-button data-cy="drawer-cancel-button" @click="onDrawerClose" class="ant-btn mr-2" :disabled="processing">
                {{ $t('template.forms.main.buttons.cancel') }}
            </a-button>
            <ui-submit-button data-cy="drawer-save-btn" :disabled="processing">
                <span v-if="!processing">{{ $t('template.forms.main.buttons.save') }}</span>
                <span v-else>{{ $t('template.forms.main.buttons.saving') }}</span>
            </ui-submit-button>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiTextArea from '@/components/ui/TextArea.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiLabel,
        UiTextArea,
        UiSubmitButton,
    },
    validations: {
        template: {
            certificate_code: { required },
            certificate_type: { required },
            section_1_label: {},
            section_1: {},
            section_2_label: {},
            section_2: {},
            section_3_label: {},
            section_3: {},
            section_4_label: {},
            section_4: {},
        },
    },
    props: {
        template: Object,
        processing: Boolean,
        validation: Object,
        is_company_section: {
            type: Boolean,
            default: false,
        },
        form_mode: {
            type: String,
            default: 'init',
        },
    },
    methods: {
        isFormDirty() {
            this.$emit('is-form-dirty', this.v$.$anyDirty);
        },
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit');
        },
        onDrawerClose() {
            this.$emit('onDrawerClose');
        },
    },
};
</script>
